export default "__VITE_ASSET__3a8f1e22__"